<template>
    <v-btn v-if="!isCurrentFileShared"
           :disabled="isDisabled"
           @click="shareFile(currentFile)"
           v-tippy
           content="Share with Guests"
    >
        <v-icon class="material-icons">mdi-share</v-icon>
    </v-btn>

    <v-btn v-else
           :disabled="isDisabled"
           @click="unshareFile(currentFile)"
           v-tippy
           content="Unshare"
    >
        <v-icon class="material-icons">block</v-icon>
    </v-btn>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import FilenameMixin from "@/mixins/Filename";
import { mapGetters, mapState } from "vuex";

export default {
    mixins: [CanMixin, FilenameMixin],
    computed: {
        ...mapState("App", ["IDT", "blockLoading"]),
        ...mapState("Projects", ['image', 'currentFile']),
        ...mapGetters('Projects', ['isCurrentFileShared']),
        ...mapGetters('User', ['isGuest']),
        isDisabled() {
            return !this.image || this.IDT.initial || !this.canShareAsset || !this.currentFile.type || !['image', 'candidate'].includes(this.currentFile.type)
        }
    },

    methods: {
        async shareFile(file) {
            if (this.isDisabled) return;

            let file_id = file.id;

            if (file.type == 'candidate') {
                let activeCandidate = await window.lutify.fetchCandidate(this.$store.getters["Projects/candidateById"](this.$store.state.Projects.candidate));
                let activeCandidateBlocks = activeCandidate.blocks.map(block => _.omit(block, ['expanded']));
                if (JSON.stringify(activeCandidateBlocks).replaceAll('"', '') !== JSON.stringify(lutify.getRawBlocksData(['expanded'])).replaceAll('"', '')) {
                    file_id = await lutify.createCandidateAndAutoShare();
                }
            }

            if (file.type == 'image') {
                file_id = await lutify.createCandidateAndAutoShare();
            }

            // window.UI.message.activate("Coming Soon");
            await this.$store.dispatch("Projects/addTag", {
                file_ids: [file_id],
                tag_name: "shared",
                tag_value: "shared",
            });

            window.UI.message.activate(`Item added to Shared folder`);

            await this.$store.dispatch("Projects/refreshProjectTree");
        },

        async unshareFile(file) {
            if (this.isDisabled) return;

            await this.$store.dispatch("Projects/removeTag", {
                file_ids: [file.id],
                tag_name: "shared",
                tag_value: "shared",
            });

            window.UI.message.activate(`Item removed from Shared folder`);

            await this.$store.dispatch("Projects/refreshProjectTree");
        },
    }
}
</script>